//component
import SpotlightSection from  '@/components/elements/spotlight/elements/SpotlightSection';

//hooks
import { SpotlightContext } from '@/context/SpotlightContext';
import { useContext, useEffect } from 'react';

//styling
import "../../../css/spotlight/spotlightCarousel.scss";




const SpotlightCarousel = () => {
    const { spotlightItem, getSpotlight, isLoadingSpotlightItem, isLoading} = useContext(SpotlightContext);
    
    useEffect(()=> {
        getSpotlight();
    },[])

    if (!spotlightItem && !isLoadingSpotlightItem && !isLoading) {
        return
    }
    return (
        <SpotlightSection
            isLoading={isLoadingSpotlightItem || isLoading}
            item={spotlightItem}
        />
    )
};

export default SpotlightCarousel;
